import ScrollingBar from "./ScrollingBar";

const Expertise = () => {
    const frameworkNames = [
        "typescript", 
        "javascript", 
        "react", 
        "python", 
        "django", 
        "cplusplus", 
        "html", 
        "css", 
        "tailwindcss", 
        "node", 
        "figma", 
        "vscode", 
        "linux", 
        "macos", 
        "git", 
        "nginx", 
        "docker", 
        "express", 
        "api",
        "odoo",
        "nextjs"
    ];

  return (
    <div className="w-[80%] h-[100%] lg:h-[100vh] flex flex-col items-center justify-between pt-24 pb-24"> {/* Adjust the margin-top to the height of Hero */}
        <div className="text-[30px] text-white mb-[100px]" data-aos="fade-up" data-aos-duration="1200">Expertise</div>
        <div className="flex flex-col md:flex-row justify-between gap-4 w-full">
            <div className="flex flex-col text-left items-center justify-center md:justify-start md:items-start w-full">
                <div className="flex flex-col-reverse md:flex-row items-center" data-aos="fade-up" data-aos-duration="900" data-aos-delay="50">
                    <div className="h-1 w-8 bg-customGreen"></div>
                    <span className="text-[25px] md:ml-4 text-white font-semibold">Frontend Development</span>
                </div>
                <div className="text-white text-[16px] items-center w-[90%] md:pl-4 text-center md:text-left" data-aos="fade-up" data-aos-duration="900" data-aos-delay="150">Specialized in building responsive, user-friendly interfaces using modern frameworks and technologies. Skilled in translating design concepts into seamless digital experiences, optimizing performance, and ensuring accessibility across devices.</div>
                <div className="flex flex-col-reverse md:flex-row items-center mt-8" data-aos="fade-up" data-aos-duration="900" data-aos-delay="50">
                    <div className="h-1 w-8 bg-customGreen"></div>
                    <span className="text-[25px] md:ml-4 text-white font-semibold">Backend Development</span>
                </div>
                <div className="text-white text-[16px] items-center w-[90%] md:pl-4 text-center md:text-left" data-aos="fade-up" data-aos-duration="900" data-aos-delay="150">Proficient in designing and implementing robust backend systems. Expertise in database management, API development, and server-side logic to support scalable, secure, and efficient applications.</div>
            </div>
            <div className="flex flex-col text-left items-center justify-center md:justify-start md:items-start w-full">
                <div className="flex flex-col-reverse md:flex-row items-center" data-aos="fade-up" data-aos-duration="900" data-aos-delay="50">
                    <div className="h-1 w-8 bg-customGreen"></div>
                    <span className="text-[25px] md:ml-4 text-white font-semibold">Digital Transformation</span>
                </div>
                <div className="text-white text-[16px] items-center w-[90%] md:pl-4 text-center md:text-left" data-aos="fade-up" data-aos-duration="900" data-aos-delay="150">Experienced in leading digital transformation initiatives to modernize business processes. Focused on adopting innovative technologies, enhancing operational efficiency, and driving organizational growth in the digital era.</div>
                <div className="flex flex-col-reverse md:flex-row items-center mt-8" data-aos="fade-up" data-aos-duration="900" data-aos-delay="50">
                    <div className="h-1 w-8 bg-customGreen"></div>
                    <span className="text-[25px] md:ml-4 text-white font-semibold">Startup Management</span>
                </div>
                <div className="text-white text-[16px] items-center w-[90%] md:pl-4 text-center md:text-left" data-aos="fade-up" data-aos-duration="900" data-aos-delay="150">Skilled in launching and scaling startups, with hands-on experience in strategic planning, team leadership, and product development. Adept at fostering innovation, managing resources, and achieving business goals in fast-paced environments.</div>
            </div>
        </div>
        <div className="flex flex-row gap-4 items-center mt-[60px] w-[90%] md:w-[50%]" data-aos="fade-up" data-aos-duration="900" data-aos-delay="150">
            <ScrollingBar frameworkNames={frameworkNames} />
        </div>
    </div>
  );
}

export default Expertise;
